<form [formGroup]="form" (ngSubmit)="onSave()">
  <mat-form-field>
    <mat-label>Category Name</mat-label>
    <input matInput formControlName="name" />
  </mat-form-field>
  <div class="buttons">
    <button matButton="elevated" class="green-confirm" type="submit" [disabled]="form.invalid">
      Speichern
    </button>
    <button matButton="elevated" color="warn" (click)="onCancel()">Abbrechen</button>
  </div>
</form>